import React from 'react';
import { Link } from 'react-router-dom';

const createDropDownLink = props => {
  return (
    <li>
      <Link
        to={
          props.link.includes('/software/') || props.link.includes('/services/')
            ? `${props.link}`
            : props.link
        }
      >
        {props.name}
      </Link>
    </li>
  );
};

export default createDropDownLink;
